import { connect } from 'react-redux';

import { dollarsFormatter } from 'legacy/utils/formatters';

import { getAvmAdjustmentDifference, getIsAvmHcEmpty } from 'selectors/avms';
import {
  getReportStatusInitialLoadComplete,
  getReportStatusIsRecomputing
} from 'selectors/report-status';
import { getSubjectHasAdjustments } from 'selectors/subject';

import ValueAdjustment from 'legacy/components/ValueAdjustment';

const mapStateToProps = (state) => {
  const valueAdjustment = getAvmAdjustmentDifference(state);
  const hasAdjustments = getSubjectHasAdjustments(state);
  return {
    loading:
      !getReportStatusInitialLoadComplete(state) ||
      getReportStatusIsRecomputing(state),
    valueAdjustmentDisplay: `${
      valueAdjustment < 0 ? '-' : valueAdjustment > 0 ? '+' : ''
    }${dollarsFormatter(Math.abs(valueAdjustment))}`,
    hasAdjustments,
    isLimitedReport: getIsAvmHcEmpty(state),
    valueAdjustment
  };
};

export default connect(mapStateToProps)(ValueAdjustment);
